import React, { useState } from "react";
import { mutate } from "swr";
import { makeRequest } from "../../utils/request";
import { pushDatatoAdobeLayer } from "../../analytics/pmiAdobeLog";
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj, getAdobeAnalyticsPlayListObj } from '../../analytics/analyticsObject';
import { getUrlWithoutPathname } from "../../utils/utility";
const AddPlaylistModal = ({ contentItem, closeModal, playlists, updatePlaylist, post }) => {
  const [title, setTitle] = useState("");

  const submitForm = async () => {
    if (title !== "") {
      const playlist = {
        title: title,
        contentKeys: contentItem ? [contentItem] : []
      };
      const newPlaylist = await makeRequest("post", "/api/playlist", playlist);
      updatePlaylist && updatePlaylist([...playlists, newPlaylist]);
      await mutate(
        "/api/playlist/getplaylistwithlikes",
        [...playlists, newPlaylist]
      );
      await mutate("/api/playlist/getallplaylists", [...playlists, newPlaylist]);
      closeModal();
    }
    let industryArray = (post?.industry && post.industry.length > 0) ? (post?.industry).map(item => (item.name)) : ''
    let topicsArray = (post?.topic && post.topic.length > 0) ? (post?.topic).map(item => ',' + item.name) : ''
    let subTopicsArray = (post?.subTopic && post.subTopic.length > 0) ? (post?.subTopic).map(item => ',' + item.name) : ''
    let tagsArray = industryArray + topicsArray + subTopicsArray;
    tagsArray = tagsArray.replace(/^,/, '');
    tagsArray = tagsArray.replace(/,+/g, ',');
    let contEventObj = getAdobeAnalyticsEventObject(
      "card-cont-click",
      "card-cont-click",
      "cont-click"

    );

    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let customLObj = getAdobeAnalyticsCustomLinkObj(
      'playlist-added',
      'playlist',
      getUrlWithoutPathname()
    );
    let contObj = getAdobeAnalyticsPlayListObj({
      cont: {
        contClick: "saved",
        contID: post?.contentKey,
        contLang: post?.language,
        contName: post?.title,
        contTags: tagsArray,
        contTopic: post?.topic[0].name,
        contSource: post?.source,
        contIndustry: industryArray && industryArray.length > 0 ? industryArray[0] : 'not available',
      }
    });
    pushDatatoAdobeLayer({
      onContClickData: { ...contEventObj, ...contObj },
      customLinkData: { ...customEventObj, ...customLObj },
      pageData: false,
      adobePushTracking: false,
    });

  };

  return (
    <div
      className="fixed inset-0 overflow-auto flex"
      onClick={closeModal}
      style={{ zIndex: 60 }}
      adoberegion="playlist-added"
    >
      <div
        className="relative p-6 rounded border border-2 border-blue-600 shadow-lg bg-white max-w-sm m-auto flex-col flex"
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={closeModal}
          className="w-3 self-end cursor-pointer hover:text-red-600"
        >
          X
        </button>
        <div className="mt-4">
          <h1 className="title-font mb-4 text-3xl font-bold">Add Playlist</h1>
          <div className="mb-4">
            <label className="font-bold block mb-2 mt-5">Title</label>
            <input
              type="text"
              className="w-full appearance-none border border-gray-400 py-3 px-3 rounded text-sm"
              placeholder="Title"
              id="title"
              value={title}
              onChange={e => setTitle(e.target.value)}
            />
          </div>
          <div className="flex flex-wrap justify-between">
            <button
              className="p-3 rounded border border-blue-400 bg-white text-blue-600 hover:bg-blue-800 hover:text-white shadow font-bold"
              onClick={submitForm}
              disabled={title === ""}
            >
              Add
            </button>
            <button
              className="p-3 rounded border border-red-800 bg-white text-red-600 hover:bg-red-800 hover:text-white shadow font-bold"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPlaylistModal;
